module.exports = __webpack_public_path__ + "static/media/2016.f2c4d0a7.png";